import request from 'assets/js/http';
export function querySimple(data) {
  console.log('querySimple', data);
  return request({
    url: '/deal/querySimple',
    method: 'post',
    data: data
  });
}

export function queryStructureChart(data) {
  console.log('queryStructureChart', data);
  return request({
    url: '/deal/queryStructureChart',
    method: 'post',
    data: data
  });
}
